export const InfoFilledIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M6.9995 1.78562e-08C5.14298 0.000132617 3.36256 0.737758 2.0499 2.05061C0.737238 3.36345 -0.000132581 5.14398 1.78805e-08 7.0005C0.000132617 8.85702 0.737758 10.6374 2.05061 11.9501C3.36345 13.2628 5.14398 14.0001 7.0005 14C7.91975 13.9999 8.82999 13.8188 9.67925 13.467C10.5285 13.1151 11.3001 12.5995 11.9501 11.9494C12.6001 11.2993 13.1156 10.5276 13.4673 9.67832C13.8191 8.82902 14.0001 7.91875 14 6.9995C13.9999 6.08025 13.8188 5.17001 13.467 4.32075C13.1151 3.4715 12.5995 2.69986 11.9494 2.0499C11.2993 1.39994 10.5276 0.884374 9.67832 0.532652C8.82902 0.18093 7.91875 -6.56384e-05 6.9995 1.78562e-08ZM8.09642 9.57532C7.56846 10.3683 7.0305 10.9802 6.12656 10.9802C5.50961 10.8792 5.25562 10.4363 5.38961 9.98629L6.55253 6.13456C6.58153 6.03957 6.53453 5.93958 6.44854 5.90858C6.36255 5.87758 6.19456 5.98957 6.04857 6.14856L5.34662 6.9945C5.32662 6.85351 5.34362 6.61853 5.34362 6.52353C5.87258 5.73059 6.73952 5.10464 7.32848 5.10464C7.88844 5.16263 8.15242 5.6096 8.05542 6.10056L6.88451 9.97129C6.86951 10.0593 6.91551 10.1473 6.9945 10.1753C7.08049 10.2063 7.26148 10.0943 7.40747 9.93429L8.10942 9.08935C8.12842 9.23134 8.09642 9.48132 8.09642 9.57532ZM7.94043 4.54368C7.49546 4.54368 7.13549 4.2207 7.13549 3.74273C7.13549 3.26577 7.49646 2.94179 7.94043 2.94179C8.3854 2.94179 8.74538 3.26577 8.74538 3.74273C8.74538 4.2207 8.3854 4.54368 7.94043 4.54368Z"
        fill="#1677FF"
      />
    </svg>
  );
};
export const BuildingIcon = ({
  width = "20",
  height = "20",
  fill = "black",
  opacity = "0.45",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
    >
      <g filter="url(#filter0_ii_5035_91472)">
        <path
          d="M17.2701 16.2902H16.8601V7.46023C16.8601 7.12023 16.5801 6.83023 16.2301 6.83023H13.1501C13.0601 6.83023 13.0001 6.90023 13.0001 6.98023V16.2802H12.3301V3.37023C12.3301 2.89023 11.9301 2.49023 11.4501 2.49023H4.15008C3.67008 2.49023 3.27008 2.89023 3.27008 3.37023V16.2902H2.89008C2.58008 16.2902 2.33008 16.5402 2.33008 16.8502C2.33008 17.1602 2.58008 17.4102 2.89008 17.4102H17.2801C17.5901 17.4102 17.8401 17.1602 17.8401 16.8502C17.8401 16.5402 17.5801 16.2902 17.2701 16.2902ZM6.10008 6.06023H9.51008C9.79008 6.06023 10.0101 6.28023 10.0101 6.56023C10.0101 6.84023 9.79008 7.06023 9.51008 7.06023H6.10008C5.82008 7.06023 5.60008 6.84023 5.60008 6.56023C5.61008 6.28023 5.83008 6.06023 6.10008 6.06023ZM6.10008 8.80023H9.51008C9.79008 8.80023 10.0101 9.02023 10.0101 9.30023C10.0101 9.58023 9.79008 9.80023 9.51008 9.80023H6.10008C5.82008 9.80023 5.60008 9.58023 5.60008 9.30023C5.60008 9.02023 5.83008 8.80023 6.10008 8.80023ZM6.10008 11.5602H9.51008C9.79008 11.5602 10.0101 11.7802 10.0101 12.0602C10.0101 12.3402 9.79008 12.5602 9.51008 12.5602H6.10008C5.82008 12.5602 5.60008 12.3402 5.60008 12.0602C5.60008 11.7802 5.83008 11.5602 6.10008 11.5602Z"
          fill={fill}
          fillOpacity={opacity}
        />
      </g>
      <defs>
        <filter
          id="filter0_ii_5035_91472"
          x="2.33008"
          y="2.49023"
          width="16.5098"
          height="16.9199"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1" dy="2" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_5035_91472"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.5" dy="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_innerShadow_5035_91472"
            result="effect2_innerShadow_5035_91472"
          />
        </filter>
      </defs>
    </svg>
  );
};
export const MarkerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clipPath="url(#clip0_5024_65081)">
        <path
          d="M7 12.568C6.27083 12.568 1.75 9.05083 1.75 6.15137C1.75 3.25191 4.10054 0.901367 7 0.901367C9.89946 0.901367 12.25 3.25191 12.25 6.15137C12.25 9.05083 7.72917 12.568 7 12.568ZM7 7.75553C7.88594 7.75553 8.60417 7.0373 8.60417 6.15137C8.60417 5.26543 7.88594 4.5472 7 4.5472C6.11406 4.5472 5.39583 5.26543 5.39583 6.15137C5.39583 7.0373 6.11406 7.75553 7 7.75553Z"
          fill="black"
          fillOpacity="0.25"
        />
      </g>
      <defs>
        <clipPath id="clip0_5024_65081">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const IdIcon = ({
  width = "14",
  height = "14",
  fill = "black",
  opacity = "0.25",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
    >
      <path
        d="M8.18516 6.12598C7.63716 6.12598 7.32422 6.52529 7.32422 7.03931C7.32422 7.55332 7.63716 7.9583 8.18516 7.9583C8.73315 7.9583 9.04609 7.55474 9.04609 7.03931C9.04609 6.52529 8.73315 6.12598 8.18516 6.12598Z"
        fill={fill}
        fillOpacity={opacity}
      />
      <path
        d="M7.04297 0.699707C3.53975 0.699707 0.699219 3.54023 0.699219 7.04346C0.699219 10.5467 3.53975 13.3872 7.04297 13.3872C10.5462 13.3872 13.3867 10.5467 13.3867 7.04346C13.3867 3.54023 10.5462 0.699707 7.04297 0.699707ZM6.02061 8.72285C6.02061 8.76108 6.00645 8.77524 5.95264 8.73276L3.89941 7.04487V8.67471H3.07812V5.36123C3.07812 5.33291 3.09229 5.30884 3.14609 5.35132L5.19932 7.04346V5.40513H6.02202V8.72285H6.02061ZM8.18428 8.71719C7.24121 8.71719 6.42983 8.02476 6.42983 7.03921C6.42983 6.05366 7.24263 5.36548 8.18428 5.36548C9.12593 5.36548 9.93872 6.05366 9.93872 7.03921C9.93872 8.02476 9.12734 8.71719 8.18428 8.71719ZM10.5264 8.72285C10.2715 8.72285 10.0449 8.53027 10.0449 8.25132C10.0449 7.97236 10.2715 7.77979 10.5264 7.77979C10.777 7.77979 11.0078 7.97236 11.0078 8.25132C11.0078 8.53027 10.777 8.72285 10.5264 8.72285Z"
        fill={fill}
        fillOpacity={opacity}
      />
    </svg>
  );
};
export const LockIcon = ({
  width = "14",
  height = "14",
  fill = "black",
  opacity = "0.25",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
    >
      <path
        d="M10.8888 6.09783H4.69773V4.38672C4.69773 3.20449 5.66218 2.24005 6.8444 2.24005C8.02662 2.24005 8.99107 3.20449 8.99107 4.38672C8.99107 4.72894 9.27107 5.00894 9.61329 5.00894C9.95551 5.00894 10.2355 4.72894 10.2355 4.38672C10.2355 2.52005 8.71107 0.995605 6.8444 0.995605C4.97773 0.995605 3.45329 2.52005 3.45329 4.38672V6.09783H2.79996C2.45773 6.09783 2.17773 6.37783 2.17773 6.72005V12.4756C2.17773 12.8178 2.45773 13.0978 2.79996 13.0978H10.8888C11.2311 13.0978 11.5111 12.8178 11.5111 12.4756V6.72005C11.5111 6.37783 11.2311 6.09783 10.8888 6.09783ZM7.34218 10.0801C7.31107 10.0801 7.27996 10.1112 7.27996 10.1423V10.7334C7.27996 11.3245 7.09329 11.4178 6.8444 11.4178C6.59551 11.4178 6.40885 11.3556 6.40885 10.7334V10.2356V10.1112C6.40885 10.08 6.37773 10.0489 6.34662 10.0489C6.15996 9.92449 6.03551 9.70672 6.03551 9.42672C6.03551 8.99116 6.40885 8.61783 6.8444 8.61783C7.27996 8.61783 7.65329 8.96005 7.65329 9.42672C7.6844 9.70672 7.52885 9.92449 7.34218 10.0801Z"
        fill={fill}
        fillOpacity={opacity}
      />
    </svg>
  );
};
export const LockBigIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g filter="url(#filter0_ii_5035_91588)">
        <path
          d="M15.2 8.90231H7.24V6.92288C7.24 5.55527 8.48 4.43959 10 4.43959C11.52 4.43959 12.76 5.55527 12.76 6.92288C12.76 7.31877 13.12 7.64267 13.56 7.64267C14 7.64267 14.36 7.31877 14.36 6.92288C14.36 4.7635 12.4 3 10 3C7.6 3 5.64 4.7635 5.64 6.92288V8.90231H4.8C4.36 8.90231 4 9.22622 4 9.62211V16.2802C4 16.6761 4.36 17 4.8 17H15.2C15.64 17 16 16.6761 16 16.2802V9.62211C16 9.22622 15.64 8.90231 15.2 8.90231ZM10.64 13.509C10.6 13.509 10.56 13.545 10.56 13.581V14.2648C10.56 14.9486 10.32 15.0566 10 15.0566C9.68 15.0566 9.44 14.9846 9.44 14.2648V13.6889V13.545C9.44 13.509 9.4 13.473 9.36 13.473C9.12 13.329 8.96 13.0771 8.96 12.7532C8.96 12.2494 9.44 11.8175 10 11.8175C10.56 11.8175 11.04 12.2134 11.04 12.7532C11.08 13.0771 10.88 13.329 10.64 13.509Z"
          fill="black"
          fillOpacity="0.45"
        />
      </g>
      <defs>
        <filter
          id="filter0_ii_5035_91588"
          x="4"
          y="3"
          width="13"
          height="16"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1" dy="2" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_5035_91588"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.5" dy="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_innerShadow_5035_91588"
            result="effect2_innerShadow_5035_91588"
          />
        </filter>
      </defs>
    </svg>
  );
};
export const MarkerBigIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_5035_91568)">
        <g filter="url(#filter0_ii_5035_91568)">
          <path
            d="M10 17.5C9.04514 17.5 3.125 12.9779 3.125 9.25C3.125 5.52213 6.20309 2.5 10 2.5C13.7969 2.5 16.875 5.52213 16.875 9.25C16.875 12.9779 10.9549 17.5 10 17.5ZM10 11.3125C11.1602 11.3125 12.1007 10.3891 12.1007 9.25C12.1007 8.11094 11.1602 7.1875 10 7.1875C8.83984 7.1875 7.89931 8.11094 7.89931 9.25C7.89931 10.3891 8.83984 11.3125 10 11.3125Z"
            fill="black"
            fillOpacity="0.45"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_ii_5035_91568"
          x="3.125"
          y="2.5"
          width="14.75"
          height="17"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.5" dy="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_5035_91568"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1" dy="2" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_innerShadow_5035_91568"
            result="effect2_innerShadow_5035_91568"
          />
        </filter>
        <clipPath id="clip0_5035_91568">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
